import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKitopiLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 171 25",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		filter: "url(#filter0_d_4462_10912)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M137.209 6.41332C136.683 3.73914 135.01 1.82225 131.868 0.94414C130.643 0.602861 129.382 0.413539 128.1 0.353753C125.46 0.230444 117.785 0.275283 116.025 0.275283C115.827 0.275283 115.666 0.437204 115.666 0.636491V23.7525C115.666 23.9518 115.828 24.1137 116.028 24.1137H124.162C124.361 24.1137 124.523 23.9506 124.523 23.75L124.5 17.4874C124.5 17.4874 129.305 17.3517 130.535 17.196C133.993 16.7576 136.276 15.0898 137.027 12.4069C137.462 10.8462 137.521 7.99018 137.21 6.41457L137.209 6.41332ZM124.396 11.5288V5.85283C124.396 5.85283 129.749 5.25247 129.749 8.47096C129.749 12.1216 124.396 11.5288 124.396 11.5288Z",
				fill: "url(#paint0_linear_4462_10912)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M80.5028 23.5782C80.5065 24.0005 80.3619 24.1138 79.8668 24.1088C77.7407 24.0864 73.7816 24.0752 71.6555 24.1151C71.0183 24.1275 70.951 23.9295 70.9522 23.4761C70.9684 18.5662 70.9522 8.09738 70.9522 8.09738H66.0042C65.8047 8.09738 65.6426 7.93546 65.6426 7.73617V0.637819C65.6438 0.438532 65.8059 0.276611 66.0054 0.276611H85.593C85.7925 0.277857 85.9546 0.439777 85.9546 0.639064V7.73492C85.9546 7.93421 85.7925 8.09613 85.593 8.09613H80.509C80.509 8.09613 80.5016 21.0722 80.5016 23.5782H80.5028Z",
				fill: "url(#paint1_linear_4462_10912)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M20 0.635377C20 0.436091 20.1621 0.27417 20.3616 0.27417H24.6624C34.5472 0.27417 30.1304 10.9522 30.4509 11.1141C30.8537 11.3184 36.3092 8.9992 36.9726 5.52289C37.3853 3.35938 36.5598 1.55708 35.9825 0.589292C35.8952 0.443564 36.0261 0.27417 36.2244 0.27417H46.3361C46.4696 0.27417 46.583 0.353885 46.603 0.462247C49.1793 10.307 39.4616 11.6771 39.5439 12.1728C39.6187 12.6212 50.7679 12.3584 46.4633 24.0454C46.4484 24.0865 46.4072 24.1139 46.3586 24.1139C42.7698 24.1288 40.8769 24.0977 37.2881 24.1139C37.2444 24.1139 37.2207 24.0777 37.1871 24.0578C32.8476 21.4733 36.2843 14.5182 35.9451 13.9976C35.7306 13.7485 27.7562 15.2319 28.6939 23.8747C28.7101 24.0267 28.5069 24.1151 28.3535 24.1151H20.3616C20.1621 24.1151 20 23.9532 20 23.7539V0.635377Z",
				fill: "url(#paint2_linear_4462_10912)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M20 0.635377C20 0.436091 20.1621 0.27417 20.3616 0.27417H24.6624C34.5472 0.27417 30.1304 10.9522 30.4509 11.1141C30.8537 11.3184 36.3092 8.9992 36.9726 5.52289C37.3853 3.35938 36.5598 1.55708 35.9825 0.589292C35.8952 0.443564 36.0261 0.27417 36.2244 0.27417H46.3361C46.4696 0.27417 46.583 0.353885 46.603 0.462247C49.1793 10.307 39.4616 11.6771 39.5439 12.1728C39.6187 12.6212 50.7679 12.3584 46.4633 24.0454C46.4484 24.0865 46.4072 24.1139 46.3586 24.1139C42.7698 24.1288 40.8769 24.0977 37.2881 24.1139C37.2444 24.1139 37.2207 24.0777 37.1871 24.0578C32.8476 21.4733 36.2843 14.5182 35.9451 13.9976C35.7306 13.7485 27.7562 15.2319 28.6939 23.8747C28.7101 24.0267 28.5069 24.1151 28.3535 24.1151H20.3616C20.1621 24.1151 20 23.9532 20 23.7539V0.635377Z",
				fill: "url(#paint3_linear_4462_10912)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M109.94 4.28609C108.191 1.25444 104.45 0.14092 101.184 0.0201019C97.9694 -0.0982247 93.9317 0.241809 91.6759 2.78521C89.4139 5.33483 88.4263 8.80492 88.344 12.1206C88.2642 15.3702 89.1109 18.5936 91.0599 20.7995C94.14 24.2858 100.187 25.0007 104.46 23.6368C107.758 22.5844 110.104 20.5105 111.073 17.1899C112.246 13.1643 112.081 8.00154 109.939 4.28733L109.94 4.28609ZM100.068 16.475C98.3073 16.475 96.8796 14.522 96.8796 12.1118C96.8796 9.70171 98.3073 7.7487 100.068 7.7487C101.829 7.7487 103.257 9.70171 103.257 12.1118C103.257 14.522 101.829 16.475 100.068 16.475Z",
				fill: "url(#paint4_linear_4462_10912)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M141.404 0.582609C141.401 0.34222 141.498 0.266241 141.915 0.271224C143.502 0.28617 148.923 0.282434 150.51 0.272469C150.853 0.269978 150.952 0.332255 150.95 0.53777C150.942 4.526 150.941 19.8424 150.95 23.8294C150.95 24.0486 150.854 24.1109 150.485 24.1084C148.898 24.096 143.477 24.096 141.89 24.1084C141.5 24.1122 141.4 24.0449 141.402 23.8145C141.417 21.8253 141.417 2.56053 141.402 0.581364L141.404 0.582609Z",
				fill: "url(#paint5_linear_4462_10912)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M51.8831 0.582609C51.8806 0.34222 51.9779 0.266241 52.3944 0.271224C53.9818 0.28617 59.4024 0.282434 60.9898 0.272469C61.3327 0.269978 61.4312 0.332255 61.43 0.53777C61.4213 4.526 61.42 19.8424 61.43 23.8294C61.43 24.0486 61.334 24.1109 60.9649 24.1084C59.3775 24.096 53.9569 24.096 52.3694 24.1084C51.9791 24.1122 51.8794 24.0449 51.8819 23.8145C51.8968 21.8253 51.8968 2.56053 51.8819 0.581364L51.8831 0.582609Z",
				fill: "url(#paint6_linear_4462_10912)"
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsxs("filter", {
			id: "filter0_d_4462_10912",
			x: 0,
			y: 0,
			width: 170.95,
			height: 64.2854,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 20 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 10 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.00592142 0 0 0 0 0.428255 0 0 0 0 0.464046 0 0 0 0.2 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_4462_10912"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_4462_10912",
					result: "shape"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_4462_10912",
			x1: 126.536,
			y1: .267334,
			x2: 126.536,
			y2: 24.1137,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#93E080" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#84CE71"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_4462_10912",
			x1: 75.7986,
			y1: .276611,
			x2: 75.7986,
			y2: 24.1156,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#93E080" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#84CE71"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint2_linear_4462_10912",
			x1: 33.7257,
			y1: .27417,
			x2: 33.7257,
			y2: 24.1181,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#93E080" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#84CE71"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint3_linear_4462_10912",
			x1: 33.7257,
			y1: .27417,
			x2: 33.7257,
			y2: 24.1181,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#93E080" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#84CE71"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint4_linear_4462_10912",
			x1: 100.068,
			y1: 0,
			x2: 100.068,
			y2: 24.2853,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#93E080" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#84CE71"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint5_linear_4462_10912",
			x1: 146.176,
			y1: .270996,
			x2: 146.176,
			y2: 24.1086,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#93E080" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#84CE71"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint6_linear_4462_10912",
			x1: 56.6559,
			y1: .270996,
			x2: 56.6559,
			y2: 24.1086,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#93E080" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#84CE71"
			})]
		})
	] })]
});
export default SvgKitopiLogo;
